module.exports = __webpack_public_path__ + "img/CuCiBaju.f48da772.png";